import { BusinessCategory } from "src/entities/v3/PublisherResponse";

export const BUSINESS_CATEGORIES: BusinessCategory[] = [
  "Hardware / Electronics / Peripherals",
  "Software",
  "Internet Service Provider",
  "Cloud service",
  "Internet service",
  "Blockchain / Web3",
  "Mobile app",
  "Mobile games",
  "Mobile device",
  "Camera",
  "AV equipment",
  "Cooking / Home appliances",
  "Health and Beauty appliances",
  "Servers / Peripherals",
  "Network / Network Equipment",
  "Application",
  "Security / Cybersecurity",
  "System / Website / Application development",
  "Electronic components / Semiconductors / Electrical equipment",
  "Telecommunications / VoIP",
  "Department stores / Supermarkets / Convenience stores / Stores",
  "E-commerce",
  "Wholeseller",
  "Show Business",
  "Film / Drama",
  "Music",
  "TV",
  "Comedy",
  "Magazines / Books / Publications",
  "Manga / Anime",
  "Arts and Culture",
  "NFT",
  "Gaming",
  "Toys / Playsets / Dolls",
  "Sports",
  "Outdoors / Mountain Climbing",
  "Automotive / Automotive Supplies",
  "Motorcycles / Motorcycle Supplies",
  "Bicycle / Bicycle Supplies",
  "Automotive / Motorcycle / Bicycle",
  "Car / Car Supplies",
  "Interior / Furniture / Storage",
  "Daily necessities / Household goods",
  "Garden / DIY",
  "Interior / Goods",
  "Apparel",
  "Jewelry / Accessories",
  "Kids / Baby / Maternity",
  "Food / Sweets",
  "Soft Drinks / Alcoholic drinks",
  "Restaurant / Fast food / Streetfood",
  "Eating at home / Delivery",
  "Skin care / Cosmetics / Hair products",
  "Diet / Health food / Supplement",
  "Fitness / Healthcare",
  "Medical / Hospital",
  "Pharmaceuticals",
  "Welfare / Nursing / Rehabilitation",
  "Pets / Pet Supplies",
  "Gifts / Flowers",
  "Love / Marriage",
  "Childbirth / Childcare",
  "Funeral",
  "Female Related",
  "Hotels / inns",
  "Travel / Sightseeing",
  "Theme Park / Amusement park",
  "Residential / Condominium",
  "Commercial facilities / Office buildings",
  "Architecture / Space design",
  "Construction / Civil engineering",
  "Real Estate / Architecture / Construction",
  "Full time job / Part-time job / Career",
  "Qualifications / Study Abroad / Language",
  "School / University",
  "Cram school / Preparatory school / Online education",
  "Childcare / Early childhood education",
  "HR / Recruitment",
  "Venture Capitals",
  "Banks / Credit unions",
  "Credit card / Loan",
  "Securities / FX / Investment Trusts",
  "Life insurance / Non-life insurance",
  "Cryptocurrency",
  "Advertising / Promotion / Public Relations",
  "Marketing / Research",
  "Sales",
  "Management Consulting",
  "Think tank",
  "Accounting",
  "Legal / Patent / Intellectual Property",
  "Coaching / Mentoring / Consultation",
  "Moving",
  "Logistics / Warehouse / Cargo",
  "Airlines / Aviation",
  "Steel / Metal / Glass / Earth / Stone / Rubber",
  "Chemistry",
  "Electricity / Gas / Resources / Energy",
  "STEM (Science, Tech, Engineering, Math)",
  "Textile",
  "Tabacco",
  "Nature / Weather",
  "Environment / SDGs / Recycling",
  "Green technology",
  "Government / Local government",
  "Foundations / Associations",
  "Volunteer",
  "International activity",
  "Goods and services",
  "Event",
  "Campaign",
  "Survey report",
  "Financial results announcement",
  "Public company",
  "Local companies",
  "Foreign companies",
  "Startups",
  "Non Profit Organization / NGO",
  "Robotics",
  "Artificial Intelligence / AI",
  "Agriculture",
  "Fisheries",
  "Forestry",
  "Branding / Design",
  "SMEs",
];
